var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal-card",
      staticStyle: { height: "auto", width: "auto" },
    },
    [
      _c("div", { staticClass: "modal-card-head d-flex-justify-center" }, [
        _c("div", { staticClass: "d-flex-align-center d-flex-column" }, [
          _c("h2", { staticClass: "title" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t(
                    "pages.pickup_management.collect_confirmation.templates.title"
                  )
                ) +
                " "
            ),
          ]),
          _c("h2", { staticClass: "subtitle" }, [
            _vm._v(" " + _vm._s(_vm.selectedGroup.collectGroup) + " "),
          ]),
        ]),
      ]),
      _c(
        "section",
        { staticClass: "modal-card-body" },
        [
          _c(
            "b-button",
            {
              staticClass: "is-warning is-small",
              staticStyle: { "margin-bottom": "30px" },
              attrs: { "icon-left": "arrow-left" },
              on: { click: _vm.close },
            },
            [_vm._v(" " + _vm._s(_vm.$t("global.back")) + " ")]
          ),
          _c("b-loading", {
            attrs: { active: _vm.loading, "is-full-page": "" },
            on: {
              "update:active": function ($event) {
                _vm.loading = $event
              },
            },
          }),
          _c("div", { staticClass: "card-content" }, [
            _c("div", [
              _c("div", { staticClass: "d-flex-row d-flex-space-between" }, [
                _c("div", { staticClass: "first-fields" }, [
                  _c("div", [
                    _c(
                      "div",
                      { staticClass: "column" },
                      [
                        _c(
                          "b-select",
                          {
                            attrs: {
                              placeholder: _vm.$t(
                                "pages.pickup_management.mail_templates.select_placeholder"
                              ),
                            },
                            model: {
                              value: _vm.selectedTemplate,
                              callback: function ($$v) {
                                _vm.selectedTemplate = $$v
                              },
                              expression: "selectedTemplate",
                            },
                          },
                          _vm._l(_vm.templates, function (t) {
                            return _c(
                              "option",
                              { key: t.id, domProps: { value: t } },
                              [_vm._v(" " + _vm._s(t.templateName) + " ")]
                            )
                          }),
                          0
                        ),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "column right-align buttons" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button is-info",
                          attrs: { id: "pickup-step-5" },
                          on: { click: _vm.newTemplate },
                        },
                        [_c("b-icon", { attrs: { icon: "plus" } })],
                        1
                      ),
                      _vm.selectedTemplate && _vm.selectedTemplate.id
                        ? _c(
                            "button",
                            {
                              staticClass: "button is-danger",
                              on: { click: _vm.deleteTemplate },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("global.delete")) + " "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]),
                  _vm.selectedTemplate
                    ? _c("div", { staticClass: "edit-section" }, [
                        _c(
                          "div",
                          [
                            _c(
                              "b-field",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "pages.pickup_management.collect_confirmation.templates.template_name"
                                  ),
                                },
                              },
                              [
                                _c("b-input", {
                                  model: {
                                    value: _vm.selectedTemplate.templateName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.selectedTemplate,
                                        "templateName",
                                        $$v
                                      )
                                    },
                                    expression: "selectedTemplate.templateName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          [
                            _c(
                              "b-field",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "pages.pickup_management.collect_confirmation.templates.subject"
                                  ),
                                },
                              },
                              [
                                _c("b-input", {
                                  model: {
                                    value: _vm.selectedTemplate.subject,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.selectedTemplate,
                                        "subject",
                                        $$v
                                      )
                                    },
                                    expression: "selectedTemplate.subject",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          [
                            _c(
                              "b-field",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "pages.pickup_management.collect_confirmation.templates.sender"
                                  ),
                                },
                              },
                              [
                                _c("b-input", {
                                  model: {
                                    value: _vm.selectedTemplate.sender,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.selectedTemplate,
                                        "sender",
                                        $$v
                                      )
                                    },
                                    expression: "selectedTemplate.sender",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                ]),
                _c("div", [_c("collectInfoCard")], 1),
              ]),
              _vm.selectedTemplate
                ? _c("div", [
                    _c(
                      "div",
                      [
                        _c(
                          "b-field",
                          {
                            attrs: {
                              label: _vm.$t(
                                "pages.pickup_management.collect_confirmation.templates.mail_content"
                              ),
                            },
                          },
                          [
                            _c("vue-editor", {
                              model: {
                                value: _vm.selectedTemplate.content,
                                callback: function ($$v) {
                                  _vm.$set(_vm.selectedTemplate, "content", $$v)
                                },
                                expression: "selectedTemplate.content",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "button is-primary is-fullwidth",
                          class: { "is-loading": _vm.isSubmitting },
                          attrs: { type: "submit" },
                          on: { click: _vm.submit },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.submit")) + " ")]
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }